import axios from 'axios';
import {DateTime} from 'luxon';

export default {
   data() {
      return {

         //note these are to be passed to the showError component
         dialog_show_error: false,
         show_error_obj: null,


      };
   },
   watch: {
      show_error_obj(newVal, oldVal){
         if ( newVal !== null){

            this.dialog_show_error = true;
         }

      },

      dialog_show_error(newVal, oldVal){
         if (newVal === false && oldVal === true){
            this.show_error_obj = null;
         }
      }
   },


   methods: {


      /**
       * Intended to be used an
       * @param error - error object,
       *
       * @returns
       */
      show_error_details(error, info=''){

         let error2 = {};

         try{
            let msg = error.message;
            if (error.response !== undefined){
               if (error.response.data !== undefined){
                  if (error.response.data.message !== undefined){
                     msg = error.response.data.message;
                  }
                  else{
                     msg = error.response.data;
                  }
               }
            }

            let keys = Object.getOwnPropertyNames(error);
            keys.forEach(x => {
               error2[x] = error[x];
            });

            this.show_error_obj = {
               URL: window.location.href,
               CONTEXT_INFO: info,
               ERROR: error2,
               USER: this.$auth.profile,
               msg: msg,
            };

            console.error('Error Message: ', msg);
            console.error('Full Error Object: ', error2 );

            return 'An error occurred: ' + msg;
         }
         catch (e) {
            console.error('Had an error while trying to process another error.');
            console.log('Original Error: ', error2.message);
            console.log('Second Error: ', e);
         }
      },

      /**
       * Simple helper function to get index of an object in an array based on a given property
       *
       * @param array - an array of objects
       * @param attr - str, name of proprty to search for
       * @param value - value to search for

       * @returns index of item or -1 if not found
       *
       * ref: https://stackoverflow.com/questions/7176908/how-to-get-index-of-object-by-its-property-in-javascript/54015295
       */

      findWithAttr(array, attr, value, returnObj=false) {

         // console.log('array', array)
         for(let i = 0; i < array.length; i += 1) {
            let a = attr.split('.');
            let val;
            val = array[i][a[0]];


            // console.log('a', a)
            for (let j=1; j < a.length; j++) {

               val = val[a[j]];
            }

            // console.log('val', val, 'value', value)
            if(val === value) {
               if (returnObj)
                  return array[i];
               else
                  return i;
            }
         }

         if (returnObj)
            return null;
         else
            return -1;

      },

      /**
       * Helper fn to return class name for rows in data tables.
       * Note, assumes classes are defined in vue file where this is called
       *
       * @param is_active - bool, if false return css class name for inactive row.
       * @returns {string}
       */
      get_row_class(is_active){
         if (is_active){
            return 'row_active';
         }
         else{
            return 'row_inactive';
         }
      },


      /**
       * creates auth token header, and query object based on user's role/type.
       *
       * @returns base query and auth token of logged in user
       */
      async base_user_request(){
         let acct_type = this.$auth.profile.acct_type;
         let user_role = this.$auth.profile.user_role;

         let token = await this.$auth.getAxiosHeader();

         let query;

         if (user_role === 'SuperAdmin'){
            query = {};
         }

         if (acct_type === 'AGENCY'){
            query = {agency_id: this.$auth.profile.agency_id};
            // if (user_role === 'Admin'){}
            // else if (user_role === 'AcctManager'){}
            // else if (user_role === 'Grader'){}
         }
         else if (acct_type === 'CLIENT'){
            query = {agency_id: this.$auth.profile.agency_id};

            if (user_role === 'Admin') {
               query.org_id = this.$auth.profile.org_ids[0]; //note we're assuming that a client only has access to a single org
            }
            else if (user_role === 'Manager' || user_role === 'SalesPerson' ){
               query.org_id = this.$auth.profile.org_ids[0]; //note we're assuming that a client only has access to a single org
               query.dealer_id = this.$auth.profile.dealer_ids;
            }
         }

         // console.log('query', query)

         // note token really is the headers object, however, for legacy purposes we're keeping it for now
         return {query, token, headers: token};
      },


      //*************************************************************************************************************
      async get_agencies(){
         let profile = this.$auth.profile;
         // let token = await this.$auth.getAxiosHeader();
         let url = this.$baseUrlApi + '/getAgencies';

         let {token} = await this.base_user_request();

         try {
            if (profile.user_role === 'SuperAdmin'){
               let {data} = await axios.post(url,{}, token);
               return data;
            }
            else{
               let {data} = await axios.post(url,{_id: this.$auth.profile.agency_id}, token);
               return data[0];
               // throw new Error('User does not have permission')
            }


         }
         catch(err){
            // console.log(err);
            return err
         }
      },

      //*************************************************************************************************************
      async get_organizations({org_id=null, is_active=true, enrich_curricula=false}= {}){
         // let profile = this.$auth.profile;
         // let token = await this.$auth.getAxiosHeader();
         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/getOrganizations';

         delete query.dealer_id; //not applicable for this end point

         if (is_active) {
            query.is_active = true;
         }

         if (this.$auth.profile.acct_type === 'AGENCY'){
            if (org_id !== null){
               query.org_id = org_id; //note this is potentially overwriting the value set by base_user_request()
            }
         }else{
            org_id = this.$auth.profile.org_ids[0];
            if (org_id == null){
               throw Error("user doesn't have an org specified.")
            }
            query.org_id = org_id;
         }

         
         console.log('get orgs', query)

         try {
            let {data} = await axios.post(url, {query, enrich_curricula}, token);
            data = data.sort((a, b) => (a.name > b.name) ? 1 : -1);
            return data;

         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },

      //*************************************************************************************************************
      async get_dealers({org_id, grader_id, is_active=true, include_crm_info, sort=true}= {}){

         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/getDealerships';

         if (is_active) {
            query.is_active = true;
         }







         let post_data = {query: query};

         // console.log(query)
         if (this.$auth.profile.acct_type === 'AGENCY'){
            if (org_id !== undefined){
               query.org_id = org_id; //note this is potentially overwriting the value set by base_user_request()
            }

            if (grader_id !== undefined){
               query.grader_id = grader_id;
            }

            if (include_crm_info !== undefined){
               post_data.include_crm_info = include_crm_info;
            }
         }
         else if (this.$auth.profile.acct_type === 'CLIENT'){
            // if (org_id !== undefined && this.$auth.profile.org_ids.includes(org_id)){
            //    query.org_id = org_id; //note this is potentially overwriting the value set by base_user_request()
            // }

            query.org_id = this.$auth.profile.org_ids;
            query.dealer_id = this.$auth.profile.dealer_ids;
         }

         console.log('post_data', post_data)

         let {data} = await axios.post(url, post_data, token);
         if (sort){
            data.sort((a, b) => (a.name > b.name) ? 1 : -1);
         }

         return data;
      },


      //*************************************************************************************************************
      /**
       * queries users from auth0
       *
       * @param org_id    : str, objectId of organization
       * @param dealer_id :  str, objectId of organization
       * @param append_info : bool, if true then replaces objectId's with {_id, name}
       * @param acct_type   : str, value of app_metadata.acct_type to query for
       * @param user_role   : str, value of app_metadata.user_role to query for
       * @param include_on_grades   : boolean, value of app_metadata.include_on_emails.graded_leads to query for
       * @param include_on_IC   : boolean, value of app_metadata.include_on_emails.comments_internal to query for
       * @param is_active   : boolean, value of app_metadata.is_active to query for
       * @param pagination  : null |{page, itemsPerPage},  if null then all users are returned, TODO: pagination not implemented yet
       * @param email : str, allow search by email address
       * @returns {Promise<void>}
       */
      async get_users({org_id, dealer_id, append_info=true, acct_type, user_role, include_on_grades, include_on_IC,
                         include_on_reports,include_on_reports_org, include_on_reports_sp,include_on_coachup,
                         is_active, pagination=null,
                         email, sort=true, asCsv=false}={}){

         let {token, query} = await this.base_user_request();



         //note this is potentially overwriting the value set by base_user_request()
         if (this.$auth.profile.acct_type === 'AGENCY' || true){
            if (org_id !== undefined){
               query.org_id = org_id;
            }

            if (dealer_id !== undefined){
               query.dealer_id = dealer_id;
            }

            if (acct_type !== undefined){
               query.acct_type = acct_type;
            }

            if (user_role !== undefined){
               query.user_role = user_role;
            }

            if (include_on_grades !== undefined){
               query.include_on_grades = include_on_grades;
            }
            if (include_on_coachup !== undefined){
               query.include_on_coachup = include_on_coachup;
            }

            if (include_on_IC !== undefined){
               query.include_on_IC = include_on_IC;
            }

            if (include_on_reports !== undefined){
               query.include_on_reports = include_on_reports;
            }

            if (include_on_reports_org !== undefined){
               query.include_on_reports_org = include_on_reports_org;
            }


            if (include_on_reports_sp !== undefined){
               query.include_on_reports_sp = include_on_reports_sp;
            }



            if (is_active !==undefined){
               query.is_active = is_active;
            }

            if (email !==undefined){
               query.email = email;
            }

         }





         let params = {
            append_info: append_info,
            query: query,
            returnAll: true
         };



         try {
            if (asCsv){
               let url = this.$baseUrlApi + '/getUsersCsv';
               let {data} = await axios.post(url, params , token);
               return data;

            }else{
               let url = this.$baseUrlApi + '/getUsers';
               let {data} = await axios.post(url, params , token);
               if (sort){
                  data.sort((a, b) => (a.name > b.name) ? 1 : -1);
               }
               return data;
            }


         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },










      async get_users_agency_by_client({sort=true}={}){

         let {token, query} = await this.base_user_request();





         let params = {

            query: {include_on_coachup: true, acct_type: 'AGENCY'},
            returnAll: true
         };



         try {
            let url = this.$baseUrlApi + '/getUsers';
            let {data} = await axios.post(url, params , token);
            if (sort){
               data.sort((a, b) => (a.name > b.name) ? 1 : -1);
            }
            return data;


         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },


      //*************************************************************************************************************
      async get_curricula({org_id=undefined, _id=undefined, is_active=false, get_q_data=false, get_rc_data=false, c_type}= {}){
         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/getCurricula';


         if (is_active) {
            query.is_active = is_active; //note if false then don't want to include in query
         }


         if (c_type) {
            query.type = c_type;
         }

         if (this.$auth.profile.acct_type === 'AGENCY'){
            if (org_id !== undefined){
               query.org_id = org_id
            }

            if (_id !== undefined){
               query._id = _id
            }
         }else{
            delete query.org_id;
            delete query.dealer_id;

            if (_id !== undefined){
               query._id = _id
            }
         }

         let params = {get_q_data,get_rc_data, query: query};

         try {
            let {data} = await axios.post(url, params, token);
            return data.sort((a, b) => a.level > b.level? 1: -1);

         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },



      async get_admin_summary({month, groupby='dealerships'}){
         let {token, query} = await this.base_user_request();
         let url;
         url = this.$baseUrlApi + '/getAdminSummary';


         let req_data = {query, month, groupby}

         try {
            let {data} = await axios.post(url, req_data, token);

            let totals = {leads_total:0, leads_graded: 0}

            //add percent of month completed
            let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            let m = DateTime.fromISO(month, {zone: tz});
            let bdate  = m.startOf('month');
            let edate  = m.endOf('month');
            let today = DateTime.fromJSDate(new Date());

            let monthp;
            if (today < bdate)
               monthp = 0;
            else if (today > edate)
               monthp = 1;
            else{
               monthp = today.day / (edate.day-1);
            }

            for (let i=0; i<data.length; i++){
               data[i].leads_expected = monthp * data[i].leads_total;
               totals.leads_total += data[i].leads_total;
               totals.leads_graded += data[i].leads_graded;
            }


            totals.graded_percent = totals.leads_graded/totals.leads_total;

            return {data, monthp, totals};
         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }


      },





      async get_questions({org_id=undefined, is_active=false, q_type}= {}){
         let {token, query} = await this.base_user_request();
         let url;
         url = this.$baseUrlApi + '/getQuestions';

         if (is_active) {
            query.is_active = true;
         }

         if (q_type){
            query.type = q_type;
         }

         if (org_id !== undefined){
            query.org_id = org_id;
         }

         try {
            let {data} = await axios.post(url, {query: query}, token);
            return data;
         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },


      /**
       *
       * @param user_id - str, auth0 user id
       * @param _id = str, objectId of graded lead
       * @param dateRange - object, {begin, end}
       * @returns {Promise<*>}
       */
      async get_graded_leads({user_id, _id, dealer_id, org_id, dateRange, get_q_data, get_player_data}= {}){
         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/getGradedLeads';

         console.log('debug')

         //TODO: add check to ensure that if user is client, they only have access to their data

         if (org_id !== undefined)
            query.org_id = org_id;

         if (user_id !== undefined)
            query.user_id = user_id;

         if (dealer_id !== undefined)
            query.dealer_id = dealer_id;

         if (_id !== undefined)
            query._id = _id;

         let params = {
            match: query,
         };

         if (get_q_data !== undefined){
            params.get_q_data = get_q_data;
         }

         if (get_player_data !== undefined){
            params.get_player_data = get_player_data;
         }

         if (dateRange !== undefined){
            params.dateRange = dateRange;
            if (params.dateRange.type === undefined)
               params.dateRange.type = 'DateGraded'
         }


         try {
            let res = await axios.post(url, params, token);
            return res.data;

         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },


      async get_graded_leads_csv({dateRange}){
         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/getGradedLeadsCsv';


         //TODO: add check to ensure that if user is client, they only have access to their data


         let params = {
            match: query,
         };

         if (dateRange !== undefined){
            params.dateRange = dateRange;
            if (params.dateRange.type === undefined)
               params.dateRange.type = 'DateGraded'
         }


         try {
            let res = await axios.post(url, params, token);
            return res;

         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },


      async get_coachups_csv({dateRange}){
         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/getCoachupsCsv';


         //TODO: add check to ensure that if user is client, they only have access to their data


         let params = {
            match: query,
         };

         if (dateRange !== undefined){
            params.dateRange = dateRange;
            if (params.dateRange.type === undefined)
               params.dateRange.type = 'DateCoached'
         }


         try {
            let res = await axios.post(url, params, token);
            return res;

         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },

      /**
       *
       * @param fname - str, customer's first name
       * @param lname - str, customer's last name
       * @param date_in - str, date lead came in, in yyyy-mm-dd fmt
       * @returns {Promise<*>}
       */
      async get_duplicate_graded_leads({dealer_id, fname, lname, date_in}= {}){
         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/checkDuplicateLead';

         query.dealer_id = dealer_id;
         query.fname = fname;
         query.lname = lname;
         query.date_in = date_in;

         let params = {
            match: query,
         };

         try {
            let res = await axios.post(url, params, token);
            return res.data;

         }
         catch(err){
            console.log(err);
            // ans = err.response.data;
         }
      },


      /**
       *
       * @param bdate - str, ISO formatted datetime
       * @param edate - str, ISO formatted datetime
       * @param dealer_id - str, id of dealership
       * @param groupby   - dealership | salesperson
       * @param user_role   - str, client user_role,
       *
       * @returns
       */
      async get_report_card_data({bdate, edate, dealer_id, groupby, user_role}={}){

         if (bdate === undefined || edate === undefined || dealer_id === undefined || groupby === undefined ){
            throw Error('bdate, edate, and dealer_id must be specified');
         }


         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/getReportCardData';


         query.dealer_id = dealer_id;
         let payload = {
            match    : query,
            dateRange: {begin: bdate, end: edate},
         };
         payload.groupby = groupby;

         if (user_role !== undefined){
            payload.user_role = user_role;
         }


         try {

            let res = await axios.post(url, payload, token);
            return res.data;

         }
         catch(err){
            console.log(err);

         }
      },





      /**
       * Get related data for pdf report cards
       *
       * @param month
       * @param dealer_id
       * @returns {Promise<*>}
       */
      async get_reports({month, dealer_id, groupBy, append_all_grades=true, report_type='leads'}={}){

         let {token, query} = await this.base_user_request();
         let url;

         if (report_type === 'leads'){
            url = this.$baseUrlApi + '/getReports';
         }
         else if (report_type === 'coachups'){
            url = this.$baseUrlApi + '/getReportsCU';
         }


         if (dealer_id !== undefined){
            query.dealer_id = dealer_id;
         }

         if (month !== undefined){
            query.month = month;
         }





         try {

            let res = await axios.post(url, {query, groupBy, append_all_grades }, token);
            return res.data;

         }
         catch(err){
            console.log(err);

         }
      },


      /**
       * creates a pdf report cards for the dealership and month (all curricula that are defined)
       * @param month
       * @param dealer_id
       * @returns {Promise<*>}
       */
      async gen_reports({month, dealer_id, curriculum_id, org_id, sales_person_id}={}, report_type = 'leads' ){

         let {token, query} = await this.base_user_request();


         let url
         if (report_type === 'leads'){
            url = this.$baseUrlApi + '/genReportCard';
         }
         else if (report_type === 'coachups'){
            url = this.$baseUrlApi + '/genReportCardCU';
         }


         query.month = month;
         query.curriculum_id = curriculum_id;
         query.org_id = org_id;





         if (dealer_id)
            query.dealer_id = dealer_id;

         if (sales_person_id)
            query.sales_person_id = sales_person_id;

         let res = await axios.post(url, {query }, token);
         return res.data;

      },








      async get_coachups({_id}={}){

         console.log('get_coachups')

         // if (this.selectedDealership === undefined)
         //    return;


         let {token, query} = await this.base_user_request();
         let url = this.$baseUrlApi + '/getCoachups';

         query.agency_id = this.$auth.profile.agency_id;

         if (_id){
            query._id = _id;
         }


         let res = await axios.post(url, {match: query }, token);
         return res.data;



      },





      /**
       * get's file from S3
       * @param {string} file_key - S3 file Key
       *
       * @returns {Promise<void>}
       */
      async get_file(file_key){

         let token = await this.$auth.getAxiosHeader();
         let url = this.$baseUrlApi + '/getFile';

         let settings = {
            url: url,
            method: 'post',
            data: {file_key: file_key},
            responseType: 'blob', // important
            headers: token['headers'],
         };

         return await axios(settings);
      },





      /**
       * Returns the last day of the month
       *
       * NOTES: this fn doesn't not handle time or timezone properly.
       * Assumes that the date is in the timezone of interest and simply truncates the time info.
       *
       * @param date - an iso fmt date str, note only the first 10 chars are used
       *
       * returns str formatted as yyyy-mm-dd
       *
       * ref: https://stackoverflow.com/questions/222309/calculate-last-day-of-month-in-javascript
       */
      get_eom(date){

         if (typeof date === 'string'){
            let s = date.slice(0, 10).split('-');
            date = Date.UTC(s[0], s[1], s[2]);
            date = new Date(date);
            //TODO: need to handle error if date is not a properly fmt'd srr
         }
         else{
            throw Error('date must be an iso string');
         }


         //note Date uses 0...11 for months
         let month = date.getMonth();
         let year = date.getFullYear();

         if (month < 11){
            month += 1;
         }
         else {
            month = 0;
            year += 1;
         }

         let tmp = Date.UTC(year, month, 1 );
         tmp = new Date(tmp - 1);

         // console.log(date, tmp)
         return tmp.toISOString().slice(0, 10);

      },

      /**
       * returns the first day of the previous month
       * @returns {Date}
       */
      get_prev_month(){
         let d = DateTime.local();

         d = d.startOf('month');
         d = d.minus({days: 2});
         d = d.startOf('month');
         return d.toJSDate();
      },


      truncate_str(txt){
         if (typeof txt == 'string'){
            if (txt.length > 100){
               txt = txt.slice(0, 100) + '...';
            }
         }
         return txt;
      },

      /**
       * rounds
       * @param value     - value to round
       * @param precision - num of digits to round to
       * @returns {number}
       * Taken from: https://stackoverflow.com/questions/7342957/how-do-you-round-to-1-decimal-place-in-javascript
       */
      round(value, precision) {
         let multiplier = Math.pow(10, precision || 0);
         return Math.round(value * multiplier) / multiplier;
      },

      fmt_datetime(d){
         let d2 =DateTime.fromISO(d);
         return d2.toLocaleString(DateTime.DATETIME_SHORT); //{month: 'long', year: 'numeric', 'day': '2-digit'})
      },


   }, //*** methods*****

}; // export


